<template>
    <div>

        <div class="scholarship-banner" @click="moveto()">
            <!-- Left Side: Logo Container -->
            <div class="banner-left">
                <img src="../../assets/superkids/superkid-logo.svg" alt="Superkids Logo" class="logo-img">
            </div>
            
            <!-- Center: Animated Text Content -->
            <div class="banner-center">
                <h1 class="flash-text-gold">1 Million naira</h1>
                <h2 class="flash-text-white">Worth of scholarship to be won.</h2>
            </div>
            
            <!-- Right Side: Zooming Image & Ribbons -->
            <div class="banner-right">
                <div class="image-zoom-container">
                <img src="../../assets/superkids/happykid2.png" alt="Happy Winner" class="looping-zoom-img">
                </div>
                <div class="confetti c1"></div>
                <div class="confetti c2"></div>
                <div class="confetti c3"></div>
                <div class="confetti c4"></div>
                <div class="confetti c5"></div>
                <div class="confetti c5"></div>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    name: "gif",
    data() {
        return {
        }
    },
    methods: {
      moveto() {
        this.$router.push({ path: `/dashboard/superkid`})
        .catch(() => {
        });
      }
    },
}
</script>

<style  lang="scss" scoped>
/* ==========================================================================
   1. DESKTOP & GLOBAL BASE STYLES (Default View)
   ========================================================================== */

   .scholarship-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 150px; /* Fixed height requested */
  background: linear-gradient(135deg, #051937, #004d7a);
//   border-radius: 8px;
  overflow: hidden;
  position: relative;
  font-family: 'Arial Black', sans-serif;
  box-shadow: 0 4px 15px rgba(0,0,0,0.3);
  cursor: pointer;
}

/* Left Layout (Logo) */
.banner-left {
  padding-left: 20px;
  flex: 0 0 auto;
}

.logo-img {
  height: 110px;
  width: auto;
  object-fit: contain;
}

/* Center Layout (Popping & Flashing Text) */
.banner-center {
  flex: 1;
  text-align: center;
  padding: 0 15px;
  z-index: 2;
}

.flash-text-gold {
  color: #FFD700;
  font-size: 38px; /* Smooth desktop display typography */
  margin: 0;
  text-transform: uppercase;
  text-shadow: 0 0 10px rgba(255, 215, 0, 0.6);
  animation: textPopFlash 1s infinite ease-in-out;
}

.flash-text-white {
  color: #FFFFFF;
  font-size: 18px;
  margin: 5px 0 0 0;
  font-weight: bold;
  animation: textPopFlash 1s infinite ease-in-out 0.2s;
}

/* Right Layout (Happy Child Base Wrapper) */
.banner-right {
  position: relative;
  height: 100%;
  width: 200px;
  flex: 0 0 auto;
}

/* Image Zoom Animation Inner Core */
.image-zoom-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.looping-zoom-img {
  height: 150px;
  width: 100%;
  object-fit: cover;
  object-position: top center;
  animation: smoothZoom 4s infinite ease-in-out;
  transform-origin: center center;
}

/* CSS Confetti Splashing Ribbons */
.confetti {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 6px;
  height: 12px;
  border-radius: 2px;
  opacity: 0;
  z-index: 3;
}

.c1 {
  background: #FF3B30;
  animation: splashRibbon 2s infinite ease-out;
}

.c2 {
  background: #4CD964;
  animation: splashRibbon 2s infinite ease-out 0.5s;
}

.c3 {
  background: #4ca3d9;
  animation: splashRibbon 2s infinite ease-out 0.5s;
}
.c4 {
  background: #534cd9;
  animation: splashRibbon 2s infinite ease-out 0.5s;
}
.c5 {
  background: #cbd94c;
  animation: splashRibbon 2s infinite ease-out 0.5s;
}
.c6 {
  background: #a14ad4;
  animation: splashRibbon 2s infinite ease-out 0.5s;
}


/* ==========================================================================
   2. MOBILE & SMALL SCREEN MEDIA BREAKPOINT (Under 768px Width)
   ========================================================================== */
@media (max-width: 767px) {
  /* To keep content perfectly centered without cluttering, we drop the right picture on tiny devices
     and turn the left logo container into an absolute decorative backdrop watermark */
  
  .banner-right {
    display: none; /* Safely drops the child crop block layout to save screen real estate */
  }

  .banner-left {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0.15; /* Becomes a beautiful subtle background logo watermark */
    padding-left: 0;
    pointer-events: none;
  }

  .logo-img {
    height: 130px; /* Blow up logo watermark size inside container safely */
  }

  .banner-center {
    padding: 0 20px;
    text-align: center;
    width: 100%;
  }

  /* Scale font metrics downward dynamically so copy stays on one clean horizontal baseline line */
  .flash-text-gold {
    font-size: 22px; 
    letter-spacing: 0.5px;
  }

  .flash-text-white {
    font-size: 13px;
    margin-top: 3px;
    line-height: 1.2;
  }
}

/* Extra Tight Mobile Validation Fix (Under 360px screen sizes) */
@media (max-width: 359px) {
  .flash-text-gold {
    font-size: 18px;
  }
  .flash-text-white {
    font-size: 11px;
  }
}


/* ==========================================================================
   3. ANIMATION ENGINES KEYFRAMES
   ========================================================================== */

/* Text Pop & Flash Light Loop */
@keyframes textPopFlash {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
    filter: brightness(1);
  }
  50% {
    transform: scale(1.03);
    opacity: 0.9;
    filter: brightness(1.35);
  }
}

/* Image Zooming Loop Layer */
@keyframes smoothZoom {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15); /* Pulls closer seamlessly */
  }
}

/* Ribbon Explosion Loop */
@keyframes splashRibbon {
  0% {
    transform: translate(-50%, -50%) scale(0) rotate(0deg);
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    transform: translate(-120px, -60px) scale(1.2) rotate(360deg);
    opacity: 0;
  }
}



</style>